import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslationService } from '@core/services/translation.service';
import { DebugModeService } from '@shared/services/debug-mode.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private translationService = inject(TranslationService);
  private meta = inject(Meta);
  private debugModeService = inject(DebugModeService);

  langChangeInProgress = signal<boolean>(false);

  private secret = 'debugmode';
  private buffer = '';

  constructor() {
    this.langChangeInProgress = this.translationService.loadingTranslations;
    this.addMetaData();
    this.listenToDebugMode();
  }

  private listenToDebugMode(): void {
    window.addEventListener('keydown', this.onKeyDown);
  }

  private onKeyDown = (e: KeyboardEvent) => {
    this.buffer += e.key.toLowerCase();

    // Keep buffer length reasonable
    if (this.buffer.length > this.secret.length) {
      this.buffer = this.buffer.slice(-this.secret.length);
    }

    if (this.buffer.includes(this.secret)) {
      console.warn('debug mode enabled!');
      this.debugModeService.devModeEnabled$.next(true);
    }
  };

  private addMetaData(): void {
    this.meta.updateTag({
      name: 'description',
      content:
        'Skiappen er en gratis tjeneste som gir skiløpere enkel tilgang til oppdaterte løypekart. Med Skiappen kan du raskt se hvilke løyper som er nylig preparert – enten via appen eller direkte på skiappen.no',
    });
    this.meta.updateTag({
      name: 'keywords',
      content:
        'Skiappen, ski, løype, preparering, skiløype, føre, skiføre, preppe, spor, sporet, løyper, skispor, ski tracking, skiing, cross-country skiing app, skiapp, app, norge, norway',
    });
  }
}
